import * as z from 'zod'

export const LinkedInSchema = z.object({
	username: z.string().nonempty(),
	alias: z.string().optional()
})

export type LinkedInType = z.TypeOf<typeof LinkedInSchema>